import { Text } from "@crunchyroll/cx-web-components";
import { FormattedMessage } from "react-intl";

import styles from "./FooterSection.module.scss";

const FooterSection = ({ titleId, children, className = "" }) => (
  <div className={`${className} ${styles.section}`}>
    <div className={styles.wrapper}>
      <Text
        as="h4"
        size="l"
        weight="semibold"
        isFixedSize
        className={styles.title}
      >
        <FormattedMessage id={titleId} />
      </Text>
      <ul className={styles.list}>{children}</ul>
    </div>
  </div>
);

export default FooterSection;
